import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { IntranetHomeComponent } from './pages/intranet-home/intranet-home.component';
import { AccueilPage } from './pages/accueil/accueil.page';
import { ModeDemploiPage } from './pages/mode-demploi/mode-demploi.page';
import { ModeDemploiVoirPage } from './pages/mode-demploi/mode-demploi-voir.page';
import { ModeDemploiEditerPage } from './pages/mode-demploi/mode-demploi-editer.page';
import { LoginComponent } from './pages/login/login.component';
import { VoirComposantsComponent } from './pages/gestion_stocks/composants/voir-composants.component';
import { CreerComposantComponent } from './pages/gestion_stocks/composants/creer-composant.component';
import { ModifierComposantComponent } from './pages/gestion_stocks/composants/modifier-composant.component';
import { ClassesComposantsComponent } from './pages/gestion_stocks/classes_composants/classes-composants.component';
import { LotsCartouchesComponent } from './pages/gestion_stocks/lots_cartouches/lots-cartouches.component';
import { CapteursComponent } from './pages/gestion_stocks/capteurs/capteurs.component';
import { CreerCapteurComponent } from './pages/gestion_stocks/capteurs/creer-capteur.component';
import { ModifierCapteurComponent } from './pages/gestion_stocks/capteurs/modifier-capteur.component';
import { VoirNomenclaturesComponent } from './pages/gestion_stocks/nomenclatures/voir-nomenclatures.component';
import { CreerNomenclatureComponent } from './pages/gestion_stocks/nomenclatures/creer-nomenclature.component';
import { ModifierNomenclatureComponent } from './pages/gestion_stocks/nomenclatures/modifier-nomenclature.component';
import { ClientsComponent } from './pages/clients/contacts/clients.component';
import {AdressesCreateEditComponent } from './pages/logistiques/adresses/create-edit/adresses.component';
import {AdressesListComponent } from './pages/logistiques/adresses/list/adresses.component';
import {CommandesEditComponent } from './pages/commandes/edit/commandes-edit.component';
import {CommandesCreateComponent } from './pages/commandes/create/commandes-create.component';
import {CommandesListComponent } from './pages/commandes/list/commandes-list.component';
import {CartoucheEditComponent } from './pages/gestion_stocks/cartouches/edit/cartouche-edit.component';
import {CartoucheCreateComponent } from './pages/gestion_stocks/cartouches/create/cartouche-create.component';
import {CartoucheListComponent } from './pages/gestion_stocks/cartouches/list/cartouche-list.component';
import { ImportExcelCartouchesPage } from './pages/gestion_stocks/cartouches/import_excel/import-excel.page';
import { ColisSuiviPage } from './pages/logistiques/colis-suivi/colis-suivi.page';
import { CiblesComponent } from './pages/gestion_analyses/cibles/cibles.component';
import { CouplesAmorcesComponent } from './pages/gestion_analyses/couples_amorces/couples-amorces.component';
import { GroupesAmorcesComponent } from './pages/gestion_analyses/groupes_amorces/groupes-amorces.component';
import { AttributionComponent } from './pages/gestion_analyses/attribution/attribution.component';
import { SuiviColisAnalysesComponent } from './pages/gestion_analyses/suivi_colis/suivi-colis-analyses.component';
import { CommandesSequencagePasseesComponent } from './pages/gestion_analyses/commandes_sequencage_passees/commandes-sequencage-passees.component';
import { CartouchesCommandeesComponent } from './pages/gestion_analyses/cartouches_commandees/cartouches-commandees.component';
import { CartouchesLivreesComponent } from './pages/gestion_analyses/cartouches_livrees/cartouches-livrees.component';
import { LignesPreparationListComponent } from './pages/commandes/lignes-preparation/lignes-preparation-list.component';
import { UploadAntageneComponent } from './pages/gestion_pipe/upload_antagene/upload-antagene.component';
import { ConsulterAntageneComponent } from './pages/gestion_pipe/consulter_antagene/consulter-antagene.component';
import { ResultatAnalysesComponent } from './pages/gestion_donnees/resultat_analyses/resultat-analyses.component';
import { LocalisationPage } from './pages/localisation/localisation.page';
import { CreerChimieComponent } from './pages/gestion_stocks/chimie/creer-chimie.component';
import { ModifierChimieComponent } from './pages/gestion_stocks/chimie/modifier-chimie.component';
import { VoirChimiesComponent } from './pages/gestion_stocks/chimie/voir-chimies.component';
import { AccesInterditComponent } from './pages/acces-interdit/acces-interdit.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { VerifierLivraisonsComponent } from './pages/logistiques/verifier-livraisons/verifier-livraisons.component';
import { CapteursEnCoursLivraisonComponent } from './pages/logistiques/capteurs-en-cours-livraison/capteurs-en-cours-livraison.component';
import { ExportExcelCapteurs } from './pages/gestion_metadonnees/export_excel_capteurs/export-excel-capteurs.component';
import { CartouchesEnCoursLivraisonComponent } from './pages/logistiques/cartouches-en-cours-livraison/cartouches-en-cours-livraison.component';
import { FichiersEnAttenteAnalyseTachesComponent } from './pages/taches/fichiers-en-attente-analyse/fichiers-en-attente-analyse-taches.component';
import { CartouchesLivreesSansAttributionTachesComponent } from './pages/taches/cartouches-livrees-sans-attribution/cartouches-livrees-sans-attribution-taches.component';
import { CartouchesAttribueesSansSequencageTachesComponent } from './pages/taches/cartouches-attribuees-sans-sequencage/cartouches-attribuees-sans-sequencage-taches.component';
import { RetardLivraisonCapteursTachesComponent } from './pages/taches/retard-livraison-capteurs/retard-livraison-capteurs-taches.component';
import { RetardLivraisonCartouchesTachesComponent } from './pages/taches/retard-livraison-cartouches/retard-livraison-cartouches-taches.component';
import { roleGuard } from './guards/role.guard';

export const routes: Routes = [
	{ path: 'login', component: LoginComponent },
	{
		path: 'intranet',
		component: IntranetHomeComponent,
		canActivate: [authGuard],
		children: [
			{ path: '', pathMatch: 'full', component: AccueilPage },
			{ path: 'mode-demploi', component: ModeDemploiPage },
			{ path: 'mode-demploi/:nom/voir', component: ModeDemploiVoirPage },
			{ path: 'mode-demploi/:nom/editer', component: ModeDemploiEditerPage, canActivate: [roleGuard(['admin-group'])] },
			{ path: 'acces-interdit', component: AccesInterditComponent },
			{ path: 'gestion-stocks/composants/voir', 
				component: VoirComposantsComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			}, // Accessible à tous les rôles
			{
				path: 'gestion-stocks/composants/creer',
				component: CreerComposantComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Seul les utilisateurs du groupe admin-group peuvent accéder à cette route
			},
			{
				path: 'gestion-stocks/composants/modifier',
				component: ModifierComposantComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Seul les utilisateurs du groupe veolia-operator-group peuvent accéder à cette route
			},
			{
				path: 'gestion-stocks/classes-composants/gerer',
				component: ClassesComposantsComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Seul les utilisateurs du groupe external-operator-group peuvent accéder à cette route
			},
			{ path: 'gestion-stocks/classes-composants/voir',
				 component: ClassesComposantsComponent,
				 canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Accessible à tous les rôles
			},
			{ path: 'gestion-stocks/classes-composants/creer',
				component: ClassesComposantsComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  
			},
			{ path: 'gestion-stocks/classes-composants/modifier', 
				component: ClassesComposantsComponent ,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  
			},
			{ path: 'gestion-stocks/classes-composants/supprimer', 
				component: ClassesComposantsComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  
			},
			{ path: 'gestion-stocks/lots-cartouches/gerer', 
				component: LotsCartouchesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]},
			{ path: 'gestion-stocks/lots-cartouches/voir',
				 component: LotsCartouchesComponent,
				 canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/lots-cartouches/creer',
				component: LotsCartouchesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/lots-cartouches/modifier', 
				component: LotsCartouchesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/lots-cartouches/supprimer', 
				component: LotsCartouchesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/capteurs/voir',
				 component: CapteursComponent,
				 canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/capteurs/creer',
				component: CreerCapteurComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'	])] },
			{ path: 'gestion-stocks/capteurs/modifier',
				component: ModifierCapteurComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/nomenclatures/voir',
				component: VoirNomenclaturesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/nomenclatures/creer',
				component: CreerNomenclatureComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/nomenclatures/modifier',
				component: ModifierNomenclatureComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/clients/gerer', 
				component: ClientsComponent,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/clients/voir', 
				component: ClientsComponent,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])] },
			{ path: 'gestion-stocks/clients/creer', component: ClientsComponent,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-stocks/clients/modifier', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-stocks/clients/supprimer', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-stocks/clients/export-excel', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-stocks/clients/export-xlsx', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-clients/contacts/gerer', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-clients/contacts/voir', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-clients/contacts/creer', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-clients/contacts/modifier', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-clients/contacts/supprimer', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-clients/contacts/export-xlsx', component: ClientsComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			},
			{ path: 'gestion-logistiques/adresses/voir', component: AdressesListComponent,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])] ,
			 },
			{ path: 'gestion-logistiques/adresses/creer', component: AdressesCreateEditComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] ,
			 },
			{ path: 'gestion-logistiques/adresses/modifier', component: AdressesCreateEditComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] ,
			 },
			{ path: 'commandes/voir', component: CommandesListComponent ,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])] ,
			},
			{ path: 'commandes/creer', component: CommandesCreateComponent ,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])] ,
			},
			{ path: 'commandes/modifier', component: CommandesEditComponent,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])] ,
			 },
			{ path: 'commandes/modifier/:id', component: CommandesEditComponent,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])] ,
			},
			{ path: 'gestion-livraisons/lignes-en-preparation', component: LignesPreparationListComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'gestion-stocks/cartouches/creer', component: CartoucheCreateComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Seul les utilisateurs du groupe admin-group peuvent accéder à cette route
			 },
			{ path: 'gestion-stocks/cartouches/modifier', component: CartoucheEditComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Seul les utilisateurs du groupe admin-group peuvent accéder à cette route
			 },
			{ path: 'gestion-stocks/cartouches/voir', component: CartoucheListComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Accessible à tous les rôles
			 },
			{ path: 'gestion-stocks/cartouches/import-excel', component: ImportExcelCartouchesPage,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Seul les utilisateurs du groupe admin-group peuvent accéder à cette route
			 },
			{ path: 'gestion-logistiques/suivi-colis', component: ColisSuiviPage,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]  // Accessible à tous les rôles
			 },
	
			{ path: 'gestion-analyses/cibles/voir', redirectTo: 'gestion-analyses/cibles/supprimer', pathMatch: 'full' },
			{ path: 'gestion-analyses/cibles/creer', component: CiblesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/cibles/modifier', component: CiblesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/cibles/supprimer', component: CiblesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/couples-amorces/voir', redirectTo: 'gestion-analyses/couples-amorces/supprimer', pathMatch: 'full' },
			{ path: 'gestion-analyses/couples-amorces/creer', component: CouplesAmorcesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/couples-amorces/modifier', component: CouplesAmorcesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/couples-amorces/supprimer', component: CouplesAmorcesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/groupes-amorces/voir', redirectTo: 'gestion-analyses/groupes-amorces/supprimer', pathMatch: 'full' },
			{ path: 'gestion-analyses/groupes-amorces/creer', component: GroupesAmorcesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/groupes-amorces/modifier', component: GroupesAmorcesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/groupes-amorces/supprimer', component: GroupesAmorcesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/attribution/attribuer', component: AttributionComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/attribution/voir', component: AttributionComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/attribution/export-excel', component: AttributionComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/commandes-sequencage/suivi-colis', component: SuiviColisAnalysesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/commandes-sequencage/passees', component: CommandesSequencagePasseesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/commandes-sequencage/cartouches-commandees', component: CartouchesCommandeesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-analyses/commandes-sequencage/cartouches-livrees', component: CartouchesLivreesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-pipe/vue-globale', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-pipe/planification', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-pipe/logs', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-pipe/alertes', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-pipe/uploader-antagene', component: UploadAntageneComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-pipe/consulter-antagene', component: ConsulterAntageneComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-donnees/resultat-analyses', component: ResultatAnalysesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-rapports/tableau-de-bord', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-rapports/export-pdf', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-rapports/diffusion-client', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-rapports/archivage', component: PageNotFoundComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-metadonnees/gps', component: LocalisationPage,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-metadonnees/export-excel-capteurs', component: ExportExcelCapteurs,
				canActivate: [roleGuard(['admin-group','veolia-operator-group'])]
			 },
			{ path: 'gestion-logistiques/verifier-livraisons', component: VerifierLivraisonsComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'gestion-logistiques/capteurs-en-cours-livraison', component: CapteursEnCoursLivraisonComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'gestion-logistiques/cartouches-en-cours-livraison', component: CartouchesEnCoursLivraisonComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'taches/fichiers-en-attente-analyse', component: FichiersEnAttenteAnalyseTachesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'taches/cartouches-livrees-en-attente-attribution', component: CartouchesLivreesSansAttributionTachesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'taches/cartouches-attribuees-en-attente-sequencage', component: CartouchesAttribueesSansSequencageTachesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'taches/retard-livraison-capteurs', component: RetardLivraisonCapteursTachesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'taches/retard-livraison-cartouches', component: RetardLivraisonCartouchesTachesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},

			// CRUD Chimie
			{ path: 'gestion-stocks/chimie/creer', component: CreerChimieComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'gestion-stocks/chimie/modifier', component: ModifierChimieComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: 'gestion-stocks/chimie/voir', component: VoirChimiesComponent,
				canActivate: [roleGuard(['admin-group','external-operator-group','veolia-operator-group'])]
			},
			{ path: '**', component: PageNotFoundComponent },
		]
	},
	{ path: '', pathMatch: 'full', redirectTo: 'intranet' },
	{ path: '**', component: PageNotFoundComponent }
];
